import CardCommon from '@op/components/CardCommon';
import { barIcon, lineIcon } from '@op/constants/chart';
import { useTopicLevelTwoTimeline } from '@op/pages/Summary/hooks/useTimelineData';
import React, { useMemo, useState } from 'react';
import { useIntl } from 'umi';
import { expandableLeftChartHeight } from '@op/pages/Summary/constants';
import BubbleCommon, {
  summaryPositiveAndNegativeRatioTips,
} from '@op/components/BubbleCommon';
import { LineChart } from '@op/components/ExpandablePlane';

export default function PositiveAndNegative({
  topicLevel,
  filter,
  topics,
  currentTopic,
}: {
  topicLevel: 'L1' | 'L2';
  filter: any;
  topics: Array<string>;
  currentTopic: string;
}) {
  const { formatMessage } = useIntl();
  const [chartType, setChartType] = useState('line');

  const params = useMemo(() => {
    return {
      ...filter,
      topic_one_level: [currentTopic],
    };
  }, [filter]);

  const { timelineMap, commonLoading } = useTopicLevelTwoTimeline({
    topic: topics,
    filter: params,
    topicLevel,
    indicatorsType: 'negative_mentions',
  });

  const { timelineMap: positiveTimeLineMap, commonLoading: positiveLoading } =
    useTopicLevelTwoTimeline({
      topic: topics,
      filter: params,
      topicLevel,
      indicatorsType: 'positive_mentions',
    });

  const timeline = useMemo(() => {
    const key = currentTopic || '';

    const { x, y } = timelineMap?.negative_mentions_ratio?.[key] || {};
    const { x: px, y: py } =
      positiveTimeLineMap?.positive_mentions_ratio?.[key] || {};

    return {
      newArr: [
        {
          name: 'Positive%-2',
          data: py,
          color: '#69D19C',
        },
        {
          name: 'Negative%-2',
          data: y,
          color: '#F17C86',
        },
      ],
      timeArr: px?.length > 0 ? px : x,
      legendData: [
        {
          name: 'Positive%-2',
          icon: 'circle',
          itemStyle: {
            color: '#69D19C',
          },
        },
        {
          name: 'Negative%-2',
          icon: 'circle',
          itemStyle: {
            color: '#F17C86',
          },
        },
      ],
    };
  }, [timelineMap, positiveTimeLineMap, topics]);

  return (
    <div className="dbo-topic-analysis-chart">
      <CardCommon
        contentCard
        defaultOperation={chartType}
        handleOperationsOnClick={(value: any) => setChartType(value.symbol)}
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {formatMessage({ id: 'Positive% & Negative%' })}
            <BubbleCommon
              tipsMap={summaryPositiveAndNegativeRatioTips}
              placement="top"
            ></BubbleCommon>
          </div>
        }
        operations={[lineIcon, barIcon]}
        loading={commonLoading || positiveLoading}
        loadingHeight={expandableLeftChartHeight}
      >
        <LineChart
          chartType={chartType}
          timeline={timeline}
          filter={filter}
          isRatio
        ></LineChart>
      </CardCommon>
    </div>
  );
}
